import React, { useState, useEffect } from "react";
import URI from "urijs";
import { useMutation } from "@apollo/client";
import { POST_VERIFY } from "../sessionContext";
import { useLocation } from "react-router-dom";

const Verify = () => {
  const location = useLocation();
  const [message, setMessage] = useState("");
  const params = new URI(location.pathname + location.search).search(true);
  const [verify] = useMutation(POST_VERIFY);

  useEffect(() => {
    verify({ variables: { token: params.token } })
      .then(({ data }) => {
        setMessage(data.userVerify.message);
      })
      .catch(e => {
        setMessage(e.message);
      });
  }, []);

  return (
    <div id="verify" style={{ textAlign: "center" }}>
      <h1>{message}</h1>
    </div>
  );
};

const Route = {
  path: "/verify",
  element: <Verify />
};

export { Route };
